// styles.js

export const darkTheme = {
  headerBg: '#333',
  headerColor: '#ccc',
  diagramBg: '#111',
  controlPanelBg: '#333',
  controlPanelGroupBg: '#444',
  textColor: '#ccc',
  buttonBg: '#555',
  buttonColor: '#ccc',
  resizeBg: '#555',
  fretColor: '#ccc',
  stringColor: '#ccc',
  labelColor: '#ccc',
  nodeColor: '#ccc',
  diagramButton: "#ccc",
  inlayColor: '#aaa',
  toolbarSelected: '#fff',
  toolbarUnselected: '#666',
  rootColor: '#FF0000'
};

export const lightTheme = {
  headerBg: '#777',
  headerColor: '#ccc',
  diagramBg: '#fff',
  controlPanelBg: '#777',
  controlPanelGroupBg: '#999',
  textColor: '#ccc',
  buttonBg: '#ccc',
  buttonColor: '#333',
  resizeBg: '#ccc',
  fretColor: '#000',
  stringColor: '#000',
  labelColor: '#000',
  nodeColor: '#000',
  diagramButton: "#000",
  inlayColor: '#aaa',
  toolbarSelected: '#fff',
  toolbarUnselected: '#aaa',
  rootColor: '#FF0000'
};